import { useTranslations } from 'next-intl';
import { disclaimerHeading, disclaimerPanel, disclaimerSection, link } from './nearbySchoolsModule.styles';

export const RatingsDisclaimer = () => {
  const t = useTranslations('hdp');

  return (
    <div className={disclaimerPanel}>
      <h3 className={disclaimerHeading}>{t('schoolRatingsAboutTitle')}</h3>
      <p className={disclaimerSection}>
        {t('schoolRatingsHistorically')}{' '}
        <a href="https://www.greatschools.org/gk/ratings/" target="_blank" rel="noopener noreferrer" className={link}>
          GreatSchools
        </a>{' '}
        {t('schoolRatingsDetails')}
      </p>
      <p className={disclaimerSection}>
        <strong>{t('schoolRatingsDisclaimerLabel')}:</strong> {t('schoolRatingsDisclaimer')}
      </p>
    </div>
  );
};
